import { NgModule } from '@angular/core';
import { BaseStorefrontModule, PWAModuleConfig, PwaModule } from '@spartacus/storefront';
import { SpartacusFeaturesModule } from './spartacus-features.module';
import { SpartacusConfigurationModule } from './spartacus-configuration.module';
import { ASM_FEATURE, AsmRootModule } from '@spartacus/asm/root';
import { CmsConfig, I18nConfig, provideConfig } from '@spartacus/core';
// TODO:Spartacus - // TODO:Spartacus - Variable asmTranslations has been removed and is no longer part of the public API. 
import { asmTranslationChunksConfig, asmTranslationsEn } from '@spartacus/asm/assets';

@NgModule({
  declarations: [],
  imports: [
    BaseStorefrontModule,
    SpartacusFeaturesModule,
    SpartacusConfigurationModule,
    AsmRootModule,
    PwaModule,
  ],
  exports: [BaseStorefrontModule],
  providers:  [
    provideConfig(<CmsConfig>{
    featureModules: {
      [ASM_FEATURE]: {
        module: () =>
          import('@spartacus/asm').then((m) => m.AsmModule)
      },
    }
  }),
  
    provideConfig(<I18nConfig>{
      i18n: {
        resources: {en:asmTranslationsEn},
        chunks: asmTranslationChunksConfig,
      },
    }), 
  provideConfig(<PWAModuleConfig>{
    pwa: {
      enabled: true,
      addToHomeScreen: true
    }
  },
)
  ]
})
export class SpartacusModule { }
